import { Component } from '@angular/core';

@Component({
  selector: 'app-matrix',
  standalone: false,
  templateUrl: './matrix.component.html',
  styleUrl: './matrix.component.scss'
})
export class MatrixComponent {

  truckType = ['euro','mega','jumbo','giga']
  tripType = ['inbound','return','roundtrip']
  dataSource = [
    {from:0, to:50, euro:{inbound: 0 , return: 50,roundtrip:50},mega:{inbound: 0 , return: 50,roundtrip:50}, 
    jumbo:{inbound: 0, return: 50,roundtrip:50}, giga:{inbound: 0 , return: 50,roundtrip:50}},
    {from:51, to:150, euro:{inbound: 51 , return: 150,roundtrip:150},mega:{inbound: 51, return: 150,roundtrip:150}, 
    jumbo:{inbound:51, return:150,roundtrip:150}, giga:{inbound: 51, return: 150,roundtrip:150}},
    {from:151, to:250, euro:{inbound:151, return:250,roundtrip:250},mega:{inbound:151, return:250,roundtrip:250}, 
    jumbo:{inbound:151, return:250,roundtrip:250}, giga:{inbound:151, return:250,roundtrip:250}},
    {from:251, to:400, euro:{inbound:251, return:400,roundtrip:400},mega:{inbound:251, return:400,roundtrip:400}, 
    jumbo:{inbound:251, return:400,roundtrip:400}, giga:{inbound:251, return:400,roundtrip:400}},
    {from:401, to:750, euro:{inbound:401, return:750,roundtrip:750},mega:{inbound:401, return:750,roundtrip:750}, 
    jumbo:{inbound:401, return:750,roundtrip:750}, giga:{inbound:401, return:750,roundtrip:750}}
  ]
  displayedCol = ['from','to','inbound','return','roundtrip']

}
